import companyApi from '~/clientApis/companyApi';
import { showMessageModal } from '~/clientUtils/showMessageModal';
import { FETCH_COMPANY_LIST_ERROR } from '~/consts/errorMessages';
import { getStore } from '~/mobx/AppStore';

const getCompanyList = async () => {
    const { companyStore } = getStore();
    companyStore.setGettingCompanyList(true);
    try {
        const list = await companyApi.getCompanyList();
        companyStore.setCompanyList(list);
    } catch (error) {
        showMessageModal('error', FETCH_COMPANY_LIST_ERROR);
        throw error;
    } finally {
        companyStore.setGettingCompanyList(false);
    }
};

export default getCompanyList;
